import "./App.css";
import { useRef } from "react";
import Header from "./components/Header.js";
import Banner from "./components/Banner.js";
import Section from "./components/Section.js";
import DelayWords from "./components/DelayWords.js";
import Feature from "./components/Feature.js";
import FeatureIntro from "./components/FeatureIntro.js";
import Title from "./components/Title.js";
import OthersFeat from "./components/OthersFeat.js";
import Footer from "./components/Footer.js";
import FileIcon from "./components/FileIcon.js";

function App() {
  const scrollTargets = {
    調查作業: useRef(null),
    案件管理: useRef(null),
    報表管理: useRef(null),
    圖資管理: useRef(null),
    查報管理: useRef(null),
    更多其他: useRef(null),
  };

  const scrollToSection = (sectionName) => {
    const targetRef = scrollTargets[sectionName];
    if (targetRef?.current) {
      targetRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="overflow-x-hidden">
      <Header></Header>
      <Banner></Banner>
      <div className="container mx-auto pb-4">
        <Section name={"lookie是什麼？"}>
          <div className="text-gray-500 text-sm md:text-lg tracking-wider mx-auto max-w-[60rem] text-center leading-6 lg:leading-8 py-6 px-4 md:px-2 lg:px-0">
            lookie 是拓圖科技自2022年推出的一款為
            <span className="text-black">地政事務所</span>
            測繪人員量身打造的Web工具
            <br />
            以介面簡潔、直覺、易用為特點
            <br />
            協助地政機關以系統化的方式完成現況調查任務
            <br />
            舉凡<span className="text-black">圖根點清查、鑑界拍照紀錄</span>
            ，都可以輕鬆完成
          </div>
          <div className="py-2 flex flex-row items-center w-full justify-between">
            <div className="mx-auto  w-full">
              <DelayWords></DelayWords>
            </div>
          </div>
        </Section>
        <Section name={"五大功能，調查好輕鬆！"}>
          <div className="flex flex-col items-center gap-2 py-8">
            <div className="flex flex-row gap-2 lg:gap-8">
              <Feature
                name={"調查作業"}
                onClick={() => scrollToSection("調查作業")}
              ></Feature>
              <Feature
                name={"案件管理"}
                onClick={() => scrollToSection("案件管理")}
              ></Feature>
              <Feature
                name={"報表管理"}
                onClick={() => scrollToSection("報表管理")}
              ></Feature>
            </div>
            <div className="flex flex-row gap-2 lg:gap-8">
              <Feature
                name={"圖資管理"}
                onClick={() => scrollToSection("圖資管理")}
              ></Feature>
              <Feature
                name={"查報管理"}
                onClick={() => scrollToSection("查報管理")}
              ></Feature>
              <Feature
                name={"更多其他"}
                onClick={() => scrollToSection("更多其他")}
              ></Feature>
              {/* <Feature name={"帳號管理"}></Feature> */}
            </div>
          </div>
        </Section>
        <Section name={"獨家特色，節省您的作業時間"}></Section>
      </div>
      <FeatureIntro>
        <div
          className="flex flex-col gap-2 lg:gap-6 items-center"
          id="調查作業"
          ref={scrollTargets["調查作業"]}
        >
          <Title name={"便利調查作業"}></Title>
          <div className="text-gray-500 text:lg md:text-xl tracking-wider">
            簡潔的地圖式介面，圖根點與界址點現況一目瞭然
          </div>
          <div className="py-2 px-4">
            <img
              src="./demoPic/demo1.webp"
              alt="demo1"
              className="hidden lg:block w-full rounded-md"
            ></img>
            <img
              src="./demoPic/demo1-m.webp"
              alt="demo1"
              className="lg:hidden w-full rounded-md"
            ></img>
          </div>
        </div>
      </FeatureIntro>
      <FeatureIntro>
        <div
          className="flex flex-col gap-2 lg:gap-6 items-center"
          id="案件管理"
          ref={scrollTargets["案件管理"]}
        >
          <Title name={"簡單管理案件"}></Title>
          <div className="text-gray-500 text:lg md:text-xl tracking-wider">
            掌握案件狀況，複丈調查不再是難事
          </div>
          <div className="py-2 px-4">
            <img
              src="./demoPic/demo2.webp"
              alt="demo2"
              className="hidden lg:block w-full rounded-md"
            ></img>
            <img
              src="./demoPic/demo2.gif"
              alt="demo2"
              className="lg:hidden w-full rounded-md"
            ></img>
          </div>
        </div>
      </FeatureIntro>
      <FeatureIntro>
        <div
          className="flex flex-col gap-2 lg:gap-6 items-center"
          id="報表管理"
          ref={scrollTargets["報表管理"]}
        >
          <Title name={"快速產製報表"}></Title>
          <div className="text-gray-500 text:lg md:text-xl tracking-wider">
            一鍵勾選點位，lookie幫您產出報表
          </div>
          <div className="py-2 px-4">
            <img
              src="./demoPic/demo3.webp"
              alt="demo3"
              className="hidden lg:block w-full rounded-md"
            ></img>
            <img
              src="./demoPic/demo3.gif"
              alt="demo3"
              className="lg:hidden w-full rounded-md"
            ></img>
          </div>
        </div>
      </FeatureIntro>
      <FeatureIntro>
        <div
          className="flex flex-col gap-2 lg:gap-6 items-center"
          id="圖資管理"
          ref={scrollTargets["圖資管理"]}
        >
          <Title name={"輕鬆更新圖資"}></Title>
          <div className="text-gray-500 text:lg md:text-xl tracking-wider">
            一鍵匯入圖資，讓更新圖資作業不再繁瑣
          </div>
          <FileIcon></FileIcon>
          {/* <div className="text-gray-500 text:lg md:text-xl tracking-wider text-center">
            一鍵匯入圖資。
            <br />
            上傳後系統自動判斷檔名，帶入段代碼等資料，
            <br />
            您只需選擇坐標系統，其餘的交給lookie。
          </div> */}
        </div>
      </FeatureIntro>
      <FeatureIntro>
        <div
          className="flex flex-col gap-2 lg:gap-6 items-center"
          id="查報管理"
          ref={scrollTargets["查報管理"]}
        >
          <Title name={"查報一目瞭然"}></Title>
          <div className="text-gray-500 text:lg md:text-xl tracking-wider">
            詳細記錄資訊，不怕操作錯誤
          </div>
          <div className="py-2 px-4">
            <img
              src="./demoPic/demo5.webp"
              alt="demo5"
              className="hidden lg:block w-full rounded-md"
            ></img>
            <img
              src="./demoPic/demo5.gif"
              alt="demo5"
              className="lg:hidden w-full rounded-md"
            ></img>
          </div>
        </div>
      </FeatureIntro>
      {/* <FeatureIntro>
        <div className="flex flex-col gap-2 lg:gap-6 items-center">
          <Title name={"安全帳號管理"}></Title>
          <div className="text-gray-500 text:lg md:text-xl tracking-wider">
            彈性職務設定，分工合作也兼顧資訊安全
          </div>
          <div className="py-2 px-4">
            <img src="./demoPic/demo6.webp" className="w-full"></img>
          </div>
        </div>
      </FeatureIntro> */}
      <div
        className="container mx-auto"
        id="更多其他"
        ref={scrollTargets["更多其他"]}
      >
        <Section name={"不但兼顧資訊安全，更有貼心便利功能"}>
          <div className="flex flex-col items-center lg:gap-8 py-12 ">
            <div className="grid grid-cols-1 lg:grid-cols-3  gap-x-8  w-full">
              <OthersFeat name={"簡潔易懂之介面"}>
                讓您操作時不再無所適從。
              </OthersFeat>
              <OthersFeat name={"跨裝置RWD設計"}>
                桌機、筆電、平板、手機皆可使用，出外勤好方便。
              </OthersFeat>
              <OthersFeat name={"樣式個人化"}>
                自由調整地籍圖及點位樣式，創造屬於您的風格。
              </OthersFeat>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3  gap-x-8  w-full">
              <OthersFeat name={"完整權限管理"}>
                針對權限開通相對應之功能，安全與管理更上一層。
              </OthersFeat>
              <OthersFeat name={"預防資安風險"}>
                與中華資安合作，預防常見資安風險。系統中亦可設定防護強度，讓您安心使用。
              </OthersFeat>
              <div className="w-full flex flex-row items-center gap-4 px-6 lg:px-2 xl:px-12">
                <div className="flex flex-col items-center w-full gap-2">
                  <div className="w-full border-b border-main h-[1px]"></div>
                  <div className="text-lg text-gray-700 tracking-widest">
                    立即洽詢
                  </div>
                  <div className="w-full border-b border-main h-[1px]"></div>
                </div>
                <div className="h-20 w-20 shrink-0 rounded-full bg-main text-white font-bold flex items-center justify-center">
                  7 Days
                </div>
                <div className="flex flex-col items-center w-full gap-2">
                  <div className="w-full border-b border-main h-[1px]"></div>
                  <div className="text-lg text-gray-700 tracking-widest">
                    享免費7天
                  </div>
                  <div className="w-full border-b border-main h-[1px]"></div>
                </div>
              </div>
            </div>
          </div>
        </Section>
        <Section name={"預約到府Demo，瞭解如何使用lookie吧！"}>
          <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-24 justify-center w-full">
            <div className="flex flex-col items-center gap-12 py-12 tracking-wider">
              <div className="text-gray-500 text-lg text-center leading-8">
                歡迎透過line官方帳號預約現場demo
                <br />
                我們將到府介紹lookie的使用方法！
              </div>
              <div className="flex flex-row items-center justify-center gap-12">
                <a
                  className="flex flex-col items-center gap-4 hover:text-main"
                  href="https://page.line.me/?accountId=twotool"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="./line.webp" alt="line" className="w-16 h-16"></img>
                  <div className="text-center">
                    Line 官方帳號
                    <br />
                    ＠twotool
                  </div>
                </a>
                <a
                  className="flex flex-col items-center gap-4 hover:text-main "
                  href="https://www.two-tool.com.tw"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="./two-tool.webp"
                    alt="two-tool"
                    className="w-16 h-16"
                  ></img>
                  <div>
                    拓圖科技
                    <br />
                    官方網站
                  </div>
                </a>
              </div>
            </div>
            <div className="flex flex-col items-center gap-12 py-12 tracking-wider">
              <div className="text-gray-500 text-lg text-center leading-8">
                下載lookie的操作手冊
                <br />
                詳細了解如何使用
              </div>
              <div className="flex flex-row items-center justify-center gap-12">
                <a
                  className="flex flex-col items-center gap-4 hover:text-main "
                  href="./lookie_user_manual.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="./cookie.webp" alt="" className="w-16 h-16"></img>
                  <div className="text-center">
                    lookie
                    <br />
                    操作手冊
                  </div>
                </a>
              </div>
            </div>
          </div>
        </Section>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default App;
